<template>
  <div class="legacy-mobile-values">
    <p v-if="!_g_IsUserLogged" class="state">Inicia sesión para consultar los valores.</p>
    <p v-else-if="_g_User.is_only_authenticated_user" class="state">Tu plan no incluye el listado de valores. <router-link to="/app/store">Consultar planes</router-link></p>
    <p v-else-if="_g_is_loading_stocks" class="state" role="status">Cargando valores…</p>
    <p v-else-if="!_g_Stocks.length" class="state" role="status">No hay valores. Revisa los filtros en Herramientas.</p>
    <ul v-else aria-label="Valores encontrados">
      <li v-for="stock in _g_Stocks" :key="stock.ticker" :class="{ selected: stock.ticker === (_g_SelectedTicker || {}).ticker }">
        <button type="button" class="value" :aria-label="'Ver gráfico de ' + stock.ticker" :aria-current="stock.ticker === (_g_SelectedTicker || {}).ticker ? 'true' : null" @click="select(stock)">
          <span class="identity"><strong>{{ stock.ticker }}</strong><small v-if="stock.entry_type_name" class="entry">{{ stock.entry_type_name }}</small><small v-if="stock.ticker === (_g_SelectedTicker || {}).ticker" class="current">En gráfico</small></span>
          <span class="company">{{ stock.nom || stock.name || 'Nombre no disponible' }}</span>
          <span class="market">{{ [stock.index_valor, stock.country, stock.divisa].filter(Boolean).join(' · ') }}</span>
        </button>
        <div class="indicators">
          <button v-if="inPortfolio(stock)" type="button" :aria-label="'Carteras de ' + stock.ticker" @click="open(stock, 'portfolio')"><span class="material-icons-outlined" aria-hidden="true">{{ names(stock.open_positions_portfolio_name).length ? 'account_balance_wallet' : 'schedule' }}</span></button>
          <button v-if="names(stock.folder_name).length" type="button" :aria-label="'Favoritos de ' + stock.ticker" @click="open(stock, 'favorites')"><span class="material-icons-outlined" aria-hidden="true">star</span></button>
        </div>
      </li>
    </ul>
    <LegacyMobileDialog v-if="actionStock" :title="action === 'portfolio' ? 'En tus carteras' : 'En tus favoritos'" :subtitle="actionStock.ticker + ' · ' + (actionStock.nom || '')" @close="actionStock = null">
      <template v-if="action === 'portfolio'">
        <section v-if="names(actionStock.open_positions_portfolio_name).length" class="membership"><h3>Posiciones abiertas</h3><p v-for="name in names(actionStock.open_positions_portfolio_name)" :key="'open-' + name"><span class="material-icons-outlined" aria-hidden="true">account_balance_wallet</span>{{ name }}</p></section>
        <section v-if="names(actionStock.waitings_portfolio_name).length" class="membership"><h3>Valores en espera</h3><p v-for="name in names(actionStock.waitings_portfolio_name)" :key="'waiting-' + name"><span class="material-icons-outlined" aria-hidden="true">schedule</span>{{ name }}</p></section>
      </template>
      <section v-else class="membership"><h3>Carpetas</h3><p v-for="name in names(actionStock.folder_name)" :key="name"><span class="material-icons-outlined" aria-hidden="true">star</span>{{ name }}</p></section>
      <p class="legacy-dialog-hint">Solo consulta. Puedes gestionar este valor desde el gráfico.</p>
      <template #footer><button type="button" class="primary" @click="actionStock = null">Entendido</button></template>
    </LegacyMobileDialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LegacyMobileDialog from './LegacyMobileDialog.vue';
export default {
  components: { LegacyMobileDialog },
  data: () => ({ action: null, actionStock: null }),
  computed: { ...mapGetters(['_g_Stocks', '_g_SelectedTicker', '_g_User', '_g_IsUserLogged', '_g_is_loading_stocks']) },
  methods: {
    names(value) { return [...new Set((Array.isArray(value) ? value : value ? [value] : []).filter(Boolean))]; },
    inPortfolio(stock) { return this.names(stock.open_positions_portfolio_name).length || this.names(stock.waitings_portfolio_name).length; },
    select(stock) {
      this.$store.commit('setSelectedTicker', stock);
      this.$store.commit('setToggleChartStocks', 'chart');
      this.$emit('selected');
    },
    open(stock, action) { this.actionStock = stock; this.action = action; }
  }
};
</script>
<style scoped>
ul { list-style: none; padding: 0; margin: 0; border-top: 1px solid #8883; }
li { display: flex; align-items: center; border-bottom: 1px solid #8883; min-height: 84px; }
li.selected { background: #00add90c; box-shadow: inset 3px 0 #00add9; }
button { min-height: 44px; min-width: 44px; border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
.value { flex: 1; min-width: 0; padding: 13px 16px; text-align: left; }
.identity { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
.identity strong { font-size: 15px; letter-spacing: .2px; }
.entry { font-size: 10px; padding: 1px 4px; border: 1px solid #8884; border-radius: 4px; }
.current { font-size: 10px; color: #007d9b; }
.company { display: block; font-size: 13px; line-height: 1.4; margin-top: 4px; overflow-wrap: anywhere; }
.market { display: block; font-size: 11px; opacity: .7; line-height: 1.5; margin-top: 3px; }
.indicators { display: flex; padding-right: 10px; flex-shrink: 0; color: #007d9b; }
.indicators .material-icons-outlined { font-size: 21px; }
.state { padding: 16px; }
.membership { margin-bottom: 18px; }
.membership h3 { margin: 0 0 8px; font-size: 12px; opacity: .75; }
.membership p { display: flex; align-items: center; gap: 10px; font-size: 14px; padding: 8px 0; margin: 0; overflow-wrap: anywhere; }
.membership .material-icons-outlined { font-size: 20px; color: #007d9b; }
button:focus-visible { outline: 2px solid #007e9e; outline-offset: -2px; }
</style>
